import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { withQueryParams } from '@shared/commonFunctions';
import { DrawerStyled } from '@styles/Layout/SidebarStyles';
import { useTabs } from '@shared/hooks/useTabs';
import { SidebarHead }  from './components/SidebarHead';
import { SidebarMenu }  from './components/SidebarMenu';
import { ChildMenuItem, IMenuItem } from './types';
import { isExternalLink } from './utils';

interface ISidebarProps {
  open             : boolean;
  fetchedMenuItems : IMenuItem[];
}

export const Sidebar = ({ open, fetchedMenuItems }: ISidebarProps) => {
  const { pathname } = useLocation();
  const { openTab } = useTabs();
  
  const currentRoute = `${pathname}`;

  const menu = useMemo(
    () => fetchedMenuItems.map((item) => {
      if (item.menuItemType === 'Header') {
        return item;
      }

      if (item.menuItemType !== 'Expandable' && currentRoute === item.link) {
        openTab({ 
          route: item.link,
          title: item.text,
          replaceIfNotExist: true,
        });
      }

      if (item.childMenuItems.length) {
        const expLink = item.link ? item.link : '/' + item.text.replaceAll(' ', '-').toLowerCase();

        return {
          ...item,
          link: expLink,
          childMenuItems: item.childMenuItems.map((subItem: ChildMenuItem) => {
            const { queueId, queueType, text, menuItemType } = subItem;
            let link = String(subItem.link);

            if (menuItemType === 'Queue') {
              if (!subItem.link) {
                link += '/' + text.replaceAll(' ', '-').toLowerCase();
              }

              if (queueId) {
                link = withQueryParams(link, { queueId, queueType }, false);
              }
            }

            if (currentRoute === `${expLink}${link}`) {
              openTab({ 
                route: `${expLink}${link}`, 
                title: subItem.text, 
                replaceIfNotExist: true,
              });
            }

            return {
              ...subItem,
              text: text,
              link: isExternalLink(subItem.link) ? subItem.link : link,
              queueCount: subItem.queueCount,
            };
          }),
        };
      }

      return {
        count: item.alertCount,
        ...item,
      };
    }),
    [fetchedMenuItems]
  );

  return (
    <DrawerStyled variant="persistent" anchor="left" open={open}>
      <SidebarHead />
      <SidebarMenu menu={menu} />
    </DrawerStyled>
  );
};
